export const PICTURE_CHOICE_ELEMENT_TYPE = "PICTURE_CHOICE" as const;
export const PICTURE_CHOICE_DISPLAY_TYPE = "TEXT_WITH_IMAGE" as const;
export const PICTURE_CHOICE_MIN_COLUMNS = 1;
export const PICTURE_CHOICE_MAX_COLUMNS = 5;
export const PICTURE_CHOICE_MOBILE_MAX_COLUMNS = 2;
export const PICTURE_CHOICE_DEFAULT_COLUMNS = 3;
export const PICTURE_CHOICE_DEFAULT_IMAGE_FIT = "cover" as const;
export const PICTURE_CHOICE_OTHER_VALUE = "Other" as const;

export type PictureChoiceDataType = "RADIO" | "CHECKBOX";
export type PictureChoiceImageFit = "cover" | "contain" | "fill";
export type PictureChoiceAltTextSource = "AUTO" | "CUSTOM";

export interface PictureChoiceOption {
  label: string;
  src: string;
  thumbnailUrl?: string;
  createdAt?: string;
  altText: string;
  altTextSource: PictureChoiceAltTextSource;
}

export type PictureChoiceSelectionLimit =
  | { mode: "unlimited" }
  | { mode: "exact"; exact: number | null }
  | { mode: "range"; min: number | null; max: number | null };

export interface PictureChoiceSettings {
  imageFit: PictureChoiceImageFit;
  showOptionLabel: boolean;
  selectionLimit: PictureChoiceSelectionLimit;
  otherOption?: PictureChoiceOption;
}

export interface PictureChoiceElement {
  label: string;
  tag: string;
  type: string;
  standard: boolean;
  builderElementType: typeof PICTURE_CHOICE_ELEMENT_TYPE;
  dataType: PictureChoiceDataType;
  optionDisplayType: typeof PICTURE_CHOICE_DISPLAY_TYPE;
  picklistOptionsImage: PictureChoiceOption[];
  allowCustomOption: boolean;
  spreadColumns: boolean;
  columnsNumber: number;
  pictureChoiceSettings: PictureChoiceSettings;
  [key: string]: unknown;
}

export type PictureChoiceValidationError =
  | { code: "MISSING_OPTION_IMAGE"; optionIndex: number }
  | { code: "MISSING_OPTION_LABEL"; optionIndex: number }
  | { code: "DUPLICATE_OPTION_LABEL"; optionIndex: number }
  | { code: "INVALID_EXACT_LIMIT" }
  | { code: "INVALID_RANGE_LIMIT" };

export interface PictureChoiceValidationResult {
  isValid: boolean;
  errors: PictureChoiceValidationError[];
}

export interface PictureChoiceCustomFieldPayload {
  dataType: PictureChoiceDataType;
  optionDisplayType: typeof PICTURE_CHOICE_DISPLAY_TYPE;
  allowCustomOption: boolean;
  picklistOptionsImage: Array<
    Pick<PictureChoiceOption, "label" | "src"> &
      Partial<Pick<PictureChoiceOption, "thumbnailUrl" | "createdAt">>
  >;
}
